import { groupValidators } from '@/Framework/UI/Organisms/FinalForm/validators/helpers';
import { validateMaxLength } from '@/Framework/UI/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@/Framework/UI/Organisms/FinalForm/validators/validateMinLength';
import { validateRequiredField } from '@/Framework/UI/Organisms/FinalForm/validators/validateRequiredField';

export default (values): object | null => {
  return groupValidators(
    validateMinLength({
      fieldName: 'portfolioName',
      fieldCaption: 'Portfolio name',
      value: values.portfolioName,
      length: 3,
    }),
    validateMaxLength({
      fieldName: 'portfolioName',
      fieldCaption: 'Portfolio name',
      value: values.portfolioName,
      length: 50,
    }),
    validateRequiredField(
      {
        fieldName: 'portfolioName',
        fieldCaption: 'Portfolio name',
        value: values.portfolioName,
      },
    ),
  );
};
